// extracted by mini-css-extract-plugin
export var container = "FAQList-module--container--OqCeH";
export var item = "FAQList-module--item--2APTc";
export var emoji = "FAQList-module--emoji--1Cg4i";
export var questionButton = "FAQList-module--questionButton--15Bml";
export var questionButtonIcon = "FAQList-module--questionButtonIcon--nq2bF";
export var question = "FAQList-module--question--dDY8U";
export var answerPanel = "FAQList-module--answerPanel--2qmbC";
export var answer = "FAQList-module--answer--voq1Y";
export var show = "FAQList-module--show--yaKwl";
export var showFadeInDown = "FAQList-module--show-fade-in-down--Wpi9P";
export var showFadeInUp = "FAQList-module--show-fade-in-up--68YS2";
export var hideFadeOut = "FAQList-module--hide-fade-out--1lC0E";